const baseColors = {
  // novisci official colors
  gunMetal: '#2b3240', // rgb(43, 50, 64)
  oriolesOrange: '#ec5833', // rgb(236, 88, 51)
  metallicSeaweed: '#367e8e', // rgb(54, 126, 142)
  midnightGreen: '#234a5d', // rgb(35, 74, 93)
  nyanza: '#eafce3', // rgb(234, 252, 227)
  fulvous: '#d58834', // rgb(213, 136, 52)

  // gray hues
  gray: '#8c8c8c', // rgb(140, 140, 140)
  silver: '#cccccc', // rgb(204, 204, 204)
  concrete: '#f2f2f2', // rgb(242, 242, 242)
  whiteSmoke: '#f9f9f9' // rgb(249, 249, 249)
}

export const colors = Object.assign(baseColors, {
  cardBackground: 'white',
  textGray: baseColors.gray,
  borderGray: baseColors.silver,
  backgroundGray: baseColors.whiteSmoke,
  tableRowStripedBackground: baseColors.concrete,
  error: 'rgb(221, 90, 61)',
  warning: 'rgb(245, 152, 52)'
})

export const chartColors = [
  '#d55e00', '#0072b2', '#cc79a7', '#009e73', '#f0e442', '#911f12', '#56b4e9', '#e69f00', '#92e0b3', '#333333'
]
